module.exports = __webpack_public_path__ + "img/VanguardVisionAI.1510c50a.png";